import version from '~/static/version.json'

const versionCookieName = 'cm24-version'

function setCookie ($cookies, actualVersion, maxAge, expiresDate) {
  // console.log('setting cookie', actualVersion, maxAge, expiresDate)
  $cookies.set(versionCookieName, actualVersion, {
    path: '/',
    maxAge,
    expires: expiresDate,
    sameSite: true,
    secure: true
  })
}

export default async ({ route, $axios, $cookies, req }) => {
  const expiresDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000)
  const maxAge = 60 * 60 * 24 * 365
  try {
    if (process.server) {
      // Read static/version.json directly. The Dockerfile writes it before the
      // build, and this code runs inside the very process that serves it, so the
      // value is identical to what an HTTP fetch would return.
      //
      // This used to be $axios.get('http://127.0.0.1:3000/version.json') -- a
      // blocking HTTP request the pod made to itself on every server-rendered
      // request, occupying a second event-loop turn per render. Under load that
      // self-call queued behind the traffic it was competing with.
      const { tag: actualVersion } = version
      if (actualVersion === undefined || actualVersion === null || actualVersion === '') {
        console.log('version.json does not contain a tag')
        return
      }
      setCookie($cookies, actualVersion, maxAge, expiresDate)
    } else {
      // The client MUST keep fetching over the network: the point is to compare
      // the version this tab was loaded with against the one the server is
      // serving now, so a redeploy forces a reload. A bundled value would be the
      // build-time value and the comparison would never fire.
      const actualVersionUrl = `${window.location.protocol}//${window.location.host}/version.json`
      const { status, data } = await $axios.get(actualVersionUrl)
      // console.log(data)

      if (status === 200) {
        // console.log($cookies.getAll())
        const currentVersion = $cookies.get(versionCookieName)

        const { tag: actualVersion } = data
        if (actualVersion === undefined || actualVersion === null || actualVersion === '') {
          console.error('version.json does not contain a tag')
          return
        }

        // console.log(expiresDate)
        if (currentVersion === actualVersion) {
          console.log('version is the same', currentVersion, actualVersion)
          return
        }

        console.log(
          `version changed ... from ${currentVersion} to ${actualVersion} ... trying window.location.reload()`
        )
        window.location.href = route.fullPath
      }
    }
  } catch (e) {
    console.log('could not run version comparison and reload', e)
  }
}
